<template>
  <div class="mask_main" v-if="show">
    <div class="content_box">
      <div class="mask_title">
        <img class="icon" src="@/assets/image/title_icon.png" alt="" />
        <div class="label">{{ title }}</div>
        <img @click="close" class="close" src="@/assets/image/close.png" alt="" />
      </div>
      <div class="search_box" v-if="title == '预警记录'">
        <el-select
          style="width: 21.91%; margin-left: 1.26%"
          v-model="subject"
          placeholder="请选择预警类型"
          clearable
        >
          <el-option
            v-for="(item, index) in searchList"
            :key="index"
            :label="item.dictLabel"
            :value="item.dictValue"
          >
          </el-option>
        </el-select>

        <el-input
          style="width: 21.91%; margin-left: 1.26%"
          v-model="licensePlate"
          placeholder="请输入车牌号"
        />
        <div class="search_icon"></div>
        <div class="search_text" @click="search">查询</div>
      </div>
      <div class="search_box" v-else>
        <el-input
          style="width: 21.91%; margin-left: 1.26%"
          v-model="name"
          placeholder="请输入姓名"
        />
        <el-input
          style="width: 21.91%; margin-left: 1.26%"
          v-model="phone"
          placeholder="请输入手机号"
        />
        <div class="search_icon"></div>
        <div class="search_text" @click="search">查询</div>
      </div>

      <div class="table_box">
        <el-table
          class="tableSpec"
          style="height: 100%"
          :data="tableData"
          v-if="title == '预警记录'"
          v-loading="loading"
        >
          <el-table-column label="姓名" prop="driverName" align="center" />
          <el-table-column label="车牌号" prop="licensePlate" align="center" />
          <el-table-column label="预警信息" prop="subjectName" align="center" />
          <el-table-column label="时间" prop="eventTime" align="center" />
        </el-table>
        <el-table
          class="tableSpec"
          style="height: 100%"
          :data="tableData"
          v-loading="loading"
          v-else
        >
          <el-table-column label="姓名" prop="name" align="center" />
          <el-table-column label="手机号" prop="phone" align="center" />
          <el-table-column label="证件开始日期" prop="issueDate" align="center" />
          <el-table-column label="证件开始日期" prop="expiringDate" align="center" />
          <el-table-column label="证书有效剩余天数" prop="residueDay" align="center" />
        </el-table>
        <div class="page_box">
          <el-pagination
            background
            layout="total, sizes, prev, pager, next, jumper"
            :page-sizes="[10]"
            :page-size="10"
            :total="total"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getWarnPage, getWarnCerPage, getDict } from "@/api/user";
export default {
  name: "MaskTable",
  data() {
    return {
      value: "",
      show: false,
      title: "",
      total: 0,
      options: [],
      tableData: [],
      pageSize: 10,
      pageNum: 1,
      searchValue: "",
      searchList: [],
      subject: "",
      licensePlate: "",
      loading: false,
      name: "",
      phone: "",
    };
  },

  mounted() {},

  methods: {
    getDictList() {
      if (this.title == "预警记录") {
        getDict("event_list").then((res) => {
          this.searchList = res.data;
        });
      } else {
      }
    },
    getList() {
      this.loading = true;
      if (this.title == "预警记录") {
        const params = {
          pageSize: this.pageSize,
          pageNum: this.pageNum,
          subject: this.subject,
          licensePlate: this.licensePlate,
        };
        getWarnPage(params)
          .then((res) => {
            this.tableData = res.rows;
            this.total = res.total;
          })
          .finally(() => {
            this.loading = false;
          });
      } else {
        const params = {
          pageSize: this.pageSize,
          pageNum: this.pageNum,
          name: this.name,
          phone: this.phone,
        };
        getWarnCerPage(params)
          .then((res) => {
            this.tableData = res.rows;
            this.total = res.total;
          })
          .finally(() => {
            this.loading = false;
          });
      }
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.pageNum = 1;
      console.log(`每页 ${val} 条`);
      this.getList();
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.pageNum = val;
      console.log(this.pageNum, "this.pageNumthis.pageNum");
      this.getList();
    },
    search() {
      this.reset();
    },
    reset() {
      this.tableData = [];
      this.pageSize = 10;
      this.pageNum = 1;
      this.total = 0;
      this.getList();
    },
    open(type) {
      this.title = type;
      this.show = true;
      this.reset();
      this.getDictList();
    },
    close() {
      this.show = false;
    },
  },
};
</script>
<style scoped lang="scss">
.mask_main {
  position: absolute;
  margin: auto;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  z-index: 9999;
  background: rgba(0, 20, 38, 0.78);
  display: flex;
  align-items: center;
  justify-content: center;
  .content_box {
    width: 74.3%;
    height: 74.03%;
    background: rgba(0, 30, 58, 0.72);
    box-shadow: inset 0px 0px 15px 8px rgba(97, 179, 255, 0.17);
    border-radius: 0px 0px 0px 0px;
    border: 2px solid rgba(103, 192, 255, 0.46);
    .mask_title {
      height: 5.5%;
      width: 100%;
      background: url("@/assets/image/mask_title.png") no-repeat center;
      background-size: 100% 100%;
      display: flex;
      align-items: center;
      justify-content: flex-start;
      .icon {
        height: 23.81%;
        margin-left: 0.63%;
        margin-right: 1.26%;
      }
      .label {
        flex: 1;
        font-family: YouSheBiaoTiHei;
        font-weight: 400;
        font-size: 24px;
        background: linear-gradient(90deg, #ffffff 0%, #4caeff 100%);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        text-align: left;
      }
      .close {
        height: 62%;
        aspect-ratio: 1 / 1;
        margin-right: 1.26%;
        cursor: pointer;
      }
    }
    .search_box {
      height: 10.21%;
      width: 100%;
      display: flex;
      align-items: center;
      .search_icon {
        margin-left: 1.26%;
        height: 21%;
        aspect-ratio: 1 / 1;
        background: url("@/assets/image/search.png") no-repeat center;
        background-size: 100% 100%;
        cursor: pointer;
      }
      .search_text {
        font-weight: 400;
        font-size: 16px;
        color: #fff;
        line-height: 21%;
        margin-left: 0.4%;
        cursor: pointer;
      }
    }
    .table_box {
      height: 73%;
      width: 97%;
      margin: auto;
    }
    .page_box {
      height: 17%;
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: flex-end;
    }
  }
}

::v-deep .search_box .el-select {
  height: 46.15% !important;
  border-radius: 4px;
  .el-input__icon {
    line-height: 100% !important;
  }
  .el-input {
    height: 100% !important;

    .el-input__inner {
      height: 100% !important;
      color: #fff;
      background: linear-gradient(
        134deg,
        rgba(0, 212, 255, 0.13) 0%,
        rgba(80, 176, 255, 0) 100%
      );
      border: 1px solid #4dbbff;
    }
  }
}

::v-deep .search_box .el-input {
  height: 46.15% !important;
  border-radius: 4px;
  .el-input__inner {
    height: 100% !important;
    color: #fff;
    background: linear-gradient(
      134deg,
      rgba(0, 212, 255, 0.13) 0%,
      rgba(80, 176, 255, 0) 100%
    );
    border: 1px solid #4dbbff;
  }
}

::v-deep .search_box .el-input__inner::placeholder {
  font-weight: 400;
  font-size: 16px;
  color: #93e4ff;
}
/* 谷歌 */
::v-deep .search_box .el-input__inner::-webkit-input-placeholder {
  font-weight: 400;
  font-size: 16px;
  color: #93e4ff;
}
/* 火狐 */
::v-deep .search_box .el-input__inner:-moz-placeholder {
  font-weight: 400;
  font-size: 16px;
  color: #93e4ff;
}
/*ie*/
::v-deep .search_box .el-input__inner:-ms-input-placeholder {
  font-weight: 400;
  font-size: 16px;
  color: #93e4ff;
}

::v-deep .el-table {
  thead {
    font-weight: 400;
    font-size: 16px;
    color: #93e4ff;
  }
  tr {
    background: transparent !important;
  }
}

.tableSpec {
  width: 100%;
  --el-table-border-color: rgba(222, 253, 255, 0.16);
}
:deep(.el-table) {
  background-color: transparent;
}
:deep(.el-table__expanded-cell) {
  background-color: transparent;
}
:deep(.el-table th) {
  // background-color: rgba(0, 238, 246, 0.08) !important;
  color: #00ffff;
  border-top: 1px solid #58bfff;
  background-color: transparent !important;
  // font-size: 0.06rem;
}
:deep(.el-table tr) {
  background-color: transparent !important;
  color: #ffffff;
}
:deep(.el-table td) {
  background-color: transparent !important;
}
.el-table__fixed::before {
  background-color: transparent;
}

::v-deep .el-table th.el-table__cell.is-leaf {
  border-bottom: 1px solid #58bfff !important;
}
// 去除table表格底部白色线条
::v-deep .el-table::before {
  background-color: transparent !important;
}
::v-deep .el-table td.el-table__cell,
.el-table th.el-table__cell.is-leaf {
  border-bottom: 1px dashed #093863 !important;
}

::v-deep .el-pagination__total {
  font-weight: 400;
  font-size: 16px;
  color: #fff;
}

::v-deep .page_box .el-input {
  height: 46.15% !important;
  border-radius: 4px;
  .el-input__inner {
    height: 30px;
    border-radius: 2px;
    border: 1px solid #fff;
    background: transparent !important;
  }
}

/* 谷歌 */
::v-deep .page_box .el-input__inner {
  font-weight: 400;
  font-size: 15px;
  color: #fff;
}
::v-deep .btn-prev {
  border-radius: 2px !important;
  border: 1px solid #ffffff !important;
  background: transparent !important;
  color: #fff !important;
}
::v-deep .btn-next {
  border-radius: 2px !important;
  border: 1px solid #ffffff !important;
  background: transparent !important;
  color: #fff !important;
}
::v-deep .el-pager .number {
  border-radius: 2px !important;
  border: 1px solid #ffffff !important;
  background: transparent !important;
  color: #fff !important;
  &.active {
    background: #0f77af !important;
  }
}
::v-deep .el-icon-more {
  border-radius: 2px !important;
  border: 1px solid #ffffff !important;
  background: transparent !important;
  color: #fff !important;
}
::v-deep .el-pagination__jump {
  color: #fff !important;
}

::v-deep .el-loading-mask {
  background: #093863 !important;
}
</style>
